import { render, staticRenderFns } from "./loaitruc.vue?vue&type=template&id=4157351c&scoped=true"
import script from "./loaitruc.vue?vue&type=script&lang=js"
export * from "./loaitruc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4157351c",
  null
  
)

export default component.exports